import React from 'react';

export default function PaymentRow({ payments }) {
  return (
    <table style={styles.table}>
      <thead>
        <tr>
          <th>Payment ID</th><th>Amount</th><th>Date</th>
        </tr>
      </thead>
      <tbody>
        {payments.map(p => (
          <tr key={p.id}>
            <td>{p.id}</td>
            <td>${p.amount}</td>
            <td>{p.date}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

const styles = {
  table: {
    width: '100%', borderCollapse: 'collapse',
    marginTop: '1rem', background: '#fff'
  }
};